import React from 'react';
import { useSelector } from 'react-redux';
import { EditorActions } from 'app/stores/editor/actions';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { useAppDispatch } from 'app/stores/store';
import { PrimitiveShapePicker } from './ShapePicker';
export const SpotPicker = () => {
    const dispatch = useAppDispatch();
    const selection = useSelector((state) => getProjectState(state).selection);
    const setSpotShape = React.useCallback((type) => {
        const patches = selection.reduce((accum, id) => {
            accum[id] = { type };
            return accum;
        }, {});
        dispatch(ProjectActions.itemsUpdate({ patches }));
    }, [selection, dispatch]);
    return React.createElement(PrimitiveShapePicker, { onChange: setSpotShape });
};
export const SpotDefaultsPicker = (props) => {
    const { toolId } = props;
    const dispatch = useAppDispatch();
    const onConfigChange = React.useCallback((value) => {
        dispatch(EditorActions.toolConfig({
            id: toolId,
            patch: { type: value },
        }));
    }, [toolId, dispatch]);
    return React.createElement(PrimitiveShapePicker, { onChange: onConfigChange });
};
